var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error"}},[(_vm.isInvalid)?_c('div',[_vm._v(" Error: Invalid link ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }